import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Payment } from 'services/action';
import { Button, Modal } from 'react-bootstrap';

import { DatePicker, Form, Select, Uploader } from 'ui/components';
import { formatDate, UTCFormat } from 'utilities/common';
import pdf from 'ui/assets/pdf.png';
import xlsx from 'ui/assets/xlsx.png';

import _ from 'underscore';

const PaymentMethods = [
  { value: 'Kas Tunai', label: 'Kas Tunai' },
  { value: 'Cek&Giro', label: 'Cek & Giro' },
  { value: 'Transfer Bank', label: 'Transfer Bank' },
  { value: 'Kartu Kredit', label: 'Kartu Kredit' },
];

const initialState = {
  nominal: 0,
  paid_at: {
    default: new Date(),
    formatted: formatDate(new Date(), 'YYYY-MM-DD'),
  },
  payment_method: null,
  attachments: [],
  note: ''
};

export const FormPayment = ({ data, payment, onClose }) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);

  const [{ attachments, nominal, paid_at, payment_method, note }, setState] =
    React.useState(initialState);

  const handleSubmit = async (e) => {
    const payload = {
      receivable_id: data?.id,
      paid_at: UTCFormat(paid_at?.formatted, formatDate(new Date(), 'HH:mm'), true),
      nominal: nominal,
      payment_method: payment_method?.value || '',
      attachments: attachments,
      note: note,
    };

    let req = null
    if (payment) {
      req = await Dispatch(Payment.$update(payment?.id, payload));
    } else {
      req = await Dispatch(Payment.$create(payload));
    }

    if (req?.message === 'success') {
      onClose();
    }
  };

  React.useEffect(() => {
    if (!payment) return

    let pm = null
    _.each(PaymentMethods, (i) => {
      if (i?.value === payment?.payment_method) {
        pm = i
      }
    })

    setState((prevState) => ({
      ...prevState,
      payment_method: pm,
      paid_at: {
        default: new Date(payment?.paid_at),
        formatted: formatDate(payment?.paid_at, 'YYYY-MM-DD'),
      },
      nominal: payment?.nominal,
      attachments: payment?.attachments,
      note: payment?.note
    }));

  }, [payment])

  return (
    <>
      <Modal.Body>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label required">Tanggal Pembayaran</label>
              <div
                className={
                  StateForm?.errors?.paid_at ? 'border border-danger rounded' : ''
                }
              >
                <DatePicker
                  type="normal"
                  value={paid_at?.default || null}
                  format="dd/MM/yyyy"
                  onChange={(date) => {
                    setState((prevState) => ({
                      ...prevState,
                      paid_at: {
                        default: date,
                        formatted: formatDate(date, 'YYYY-MM-DD'),
                      },
                    }));
                  }}
                  isShowTrigger
                  error={StateForm?.errors?.paid_at}
                />
              </div>

              {StateForm?.errors?.paid_at ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.paid_at}
                </div>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label required">
                Pilih Metode Pembayaran
              </label>
              <Select
                isClearable
                classNamePrefix={
                  StateForm?.errors?.payment_method ? 'is-invalid' : 'select'
                }
                placeholder=""
                value={payment_method}
                options={PaymentMethods}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    payment_method: e,
                  }))
                }
                error={StateForm?.errors?.payment_method}
              />

              {StateForm?.errors?.payment_method ? (
                <div className="invalid-feedback" style={{ display: 'block' }}>
                  {StateForm?.errors?.payment_method}
                </div>
              ) : null}
            </div>

            <Form.Input
              required
              value={nominal}
              onChange={(e) => {
                setState((prevState) => ({
                  ...prevState,
                  nominal: e.target.valueNumber,
                }));
              }}
              type="number"
              label="Nominal"
              error={StateForm?.errors?.nominal}
            />

            <Form.Textbox
              label="Catatan"
              type="text"
              value={note}
              onChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  note: e.target.value,
                }))
              }
              error={StateForm?.errors?.note}
            />

            <div>
              <label className="form-label ">Bukti Pembayaran</label>
              <div className="d-flex flex-wrap gap-2 align-items-center justify-content-around pt-2">
                <Uploader
                  setData={(e) =>
                    setState((prevState) => ({ ...prevState, attachments: e }))
                  }
                />
                {attachments?.map((d, i) => (
                  <div key={i} style={{ width: 100, height: 100 }}>
                    <img className="img-hover rounded-3" src={`${d?.includes('.pdf') ? pdf : d?.includes('.xlsx') ? xlsx : d}`} alt="" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>

      <Modal.Footer>
        <div className="row w-100">
          <div className="col">
            <Button variant="white" className="w-100" onClick={onClose}>
              Batal
            </Button>
          </div>
          <div className="col">
            <Button
              variant="primary"
              className={StateForm?.loading ? ' btn-loading w-100' : 'w-100'}
              onClick={handleSubmit}
              disabled={StateForm?.loading}
            >
              Simpan
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </>
  );
};
